import { SearchFilterBase } from '@aibees/elephant/feature/search-filters';
import { SearchType } from '@aibees/elephant/types';
import annualRevenueFilterConfig from './annual-revenue';
import certificationFilterConfig from './certification';
import companyInfoFilterConfig from './company-info';
import companyTypeFilterConfig from './company-type';
import educationFilterConfig from './education';
import employeeByDeptFilterConfig from './employee-by-dept';
import employeeSizeFilterConfig from './employee-size';
import enrichmentRequestFilterConfig from './enrichment-request';
import exportsRequestFilterConfig from './exports-request';
import foundedYearFilterConfig from './founded-year';
import fundingFilterConfig from './funding';
import headcountGrowthFilterConfig from './headcount-growth';
import industryFilterConfig from './industry';
import jobChangeFilterConfig from './job-change';
import jobRoleFilterConfig from './job-role';
import keywordsFilterConfig from './keywords';
import lablesFilterConfig from './labels';
import languageSkillsFilterConfig from './language-skills';
import listsFilterConfig from './lists';
import locationFilterConfig from './location';
import locationsWorldwideFilterConfig from './locations-worldwide';
import operationLanguageFilterConfig from './operation-language';
import peopleCompanySearchFilterConfig from './people-company-search';
import peopleInfoFilterConfig from './people-info';
import peopleSearchFilterConfig from './people-search';
import productAndServicesyFilterConfig from './product-and-services';
import profileBadgeFilterConfig from './profile-badge';
import recordsOwnershipFilterConfig from './recrods-ownership';
import relevancyFilterConfig from './relevancy';
import sicAndNaicsFilterConfig from './sic-and-naics';
import skillsFilterConfig from './skills';
import socialMediaFilterConfig from './social-media';
import socialMediaFollowersFilterConfig from './social-media-followers';
import technologiesFilterConfig from './technologies';

const filters: SearchFilterBase[] = [
  listsFilterConfig(SearchType.People),
  exportsRequestFilterConfig(SearchType.People),
  peopleInfoFilterConfig(),
  peopleSearchFilterConfig(),
  peopleCompanySearchFilterConfig(),
  jobRoleFilterConfig(),
  employeeSizeFilterConfig(),
  locationFilterConfig(SearchType.People),
  keywordsFilterConfig(SearchType.People),
  skillsFilterConfig(),
  educationFilterConfig(),
  languageSkillsFilterConfig(),
  certificationFilterConfig(),
  profileBadgeFilterConfig(),
  jobChangeFilterConfig(),
  industryFilterConfig(),
  sicAndNaicsFilterConfig(),
  productAndServicesyFilterConfig(),
  companyTypeFilterConfig(),
  technologiesFilterConfig(),
  headcountGrowthFilterConfig(),
  employeeByDeptFilterConfig(),
  annualRevenueFilterConfig(),
  fundingFilterConfig(),
  operationLanguageFilterConfig(),
  locationsWorldwideFilterConfig(),
  foundedYearFilterConfig(),
  socialMediaFilterConfig(SearchType.People),
  socialMediaFollowersFilterConfig(SearchType.People),
  companyInfoFilterConfig(),
  lablesFilterConfig(SearchType.People),
  recordsOwnershipFilterConfig(SearchType.People),
  relevancyFilterConfig(),
  enrichmentRequestFilterConfig(SearchType.People),
];

export default filters;
